<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <strong>Changing Registered Number</strong>
        </div>
        <div class="card-body">
          <div class="comment-box">
            <h4>You will need to confirm the ownership of your new number by verifying OTP received.
            </h4>
          </div>
          @if (userExists == true) {
            <alert type="danger" style="text-align: center;">
              <span>This Number already exists in the system. Please contact support.</span>
            </alert>
          }
          @if (!waitingForOtpEntering) {
            <form [formGroup]="modifyNumberForm" (ngSubmit)="onSubmit($event)"
              class="form" ngNativeValidate>
              <h4>Enter your new number</h4>
              <div class="d-flex flex-row w-100">
                <div class="flex-fill">
                  <ngx-intl-tel-input style="width : 100%; margin-bottom : 20px;"
                    placeholder="Enter New Mobile Number"
                    [cssClass]="'iti__tel-input w-100 form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15'"
                    [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National" name="registeredNumber"
                    formControlName="registeredNumber">
                  </ngx-intl-tel-input>
                </div>
              </div>
              <div class="d-flex justify-content-between bd-highlight mt-3">
                <button type="button" mat-raised-button (click)="onResetModifyNumber()">Reset</button>
                <button type="submit" mat-raised-button color="primary"
                [disabled]="!modifyNumberForm.valid">Submit</button>
              </div>
            </form>
          }
          @if (waitingForOtpEntering) {
            <section class="g-flex-centered">
              <div class="container g-py-100">
                <div class="row justify-content-center">
                  <div class="u-shadow-v21 g-bg-white rounded g-pa-50">
                    <header class="text-center mb-4">
                      <p>Please enter the secret code you received on Phone to complete number change
                      </p>
                    </header>
                    <!-- Form -->
                    <form>
                      <div fxLayout="row wrap" fxLayoutGap="5%">
                        <mat-form-field fxFlex="0 0 12%" ngClass="digit-input">
                          <input matInput [formControl]="digit1" #digit1el type="tel"
                            pattern="\d*">
                          </mat-form-field>
                          <mat-form-field fxFlex="0 0 12%" ngClass="digit-input">
                            <input matInput [formControl]="digit2" #digit2el type="tel" pattern="\d"
                              maxlength="1">
                            </mat-form-field>
                            <mat-form-field fxFlex="0 0 12%" ngClass="digit-input">
                              <input matInput [formControl]="digit3" #digit3el type="tel" pattern="\d"
                                maxlength="1">
                              </mat-form-field>
                              <mat-form-field fxFlex="0 0 12%" ngClass="digit-input">
                                <input matInput [formControl]="digit4" #digit4el type="tel" pattern="\d"
                                  maxlength="1">
                                </mat-form-field>
                                <mat-form-field fxFlex="0 0 12%" ngClass="digit-input">
                                  <input matInput [formControl]="digit5" #digit5el type="tel" pattern="\d"
                                    maxlength="1">
                                  </mat-form-field>
                                  <mat-form-field fxFlex="0 0 12%" ngClass="digit-input">
                                    <input matInput [formControl]="digit6" #digit6el type="tel" pattern="\d"
                                      maxlength="1" (keydown.enter)="onKeydown($event)"
                                      (keyup.enter)="submit()">
                                    </mat-form-field>
                                  </div>
                                  <div class="text-center mb-5">
                                    <button (click)="submitOTP()"
                                      [disabled]="(busy | async) || (!digit1.valid || !digit2.valid || !digit3.valid || !digit4.valid || !digit5.valid || !digit6.valid)"
                                      class="btn btn-block u-btn-primary rounded g-py-13" type="button">
                                      <div fxFlex></div>
                                      @if (!(busy | async)) {
                                        <div>CONTINUE</div>
                                      }
                                      @if (busy | async) {
                                        <mat-spinner [diameter]="35"></mat-spinner>
                                      }
                                      <div fxFlex></div>
                                    </button>
                                  </div>
                                  @if (errorMessage | async) {
                                    <p>{{ errorMessage | async }}</p>
                                  }
                                </form>
                                <!-- End Form -->
                              </div>
                            </div>
                          </div>
                        </section>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>